import React from 'react';
import styled from 'styled-components';
// import { Lock } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const StyledGuard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  width: 100%;
  padding: 20px;

  .card {
    background: #ffffff;
    border-radius: 16px;
    padding: 48px 32px;
    max-width: 420px;
    width: 100%;
    text-align: center;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
  }

  .icon-wrapper {
    width: 80px;
    height: 80px;
    background-color: #fff5f5; /* Soft red tint */
    color: #e53e3e;            /* Security red */
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
    font-size: 32px;
    border: 4px solid #fffcfc;
    box-shadow: 0 4px 10px rgba(229, 62, 62, 0.1);
  }

  h2 {
    color: #1a202c;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  .message {
    color: #718096;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 32px;
  }

  .action-btn {
    background-color: #3182ce;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease;
    text-decoration: none;
    display: inline-block;

    &:hover {
      background-color: #2b6cb0;
    }
  }
`;

// 2. The Logic Wrapper
const PermissionWrapper = ({ 
  
  showPlaceholder = true ,
  children
}) => {

  const navigate = useNavigate();

  const{ user } = useSelector((state) =>state.user);
  if (user?.userName === "6387421303") {
   
   return (
  <StyledGuard>
    <div className="card">
      <div className="icon-wrapper">
        <i className="fa-solid fa-shield-halved"></i>
      </div>
      <h2>Access Denied</h2>
      <p className="message">
        It looks like you don't have the necessary permissions to view this page. 
        Please contact your administrator if you believe this is a mistake.
      </p>
      <button className="action-btn" onClick={() => (navigate("/"))}>
      Return to Dashboard
      </button>
    </div>
  </StyledGuard>
);
  }

  // Return the normal wrapper with children
  return <>{children}</>;
};

export default PermissionWrapper;